import axios from 'axios';
import { getShopInfosInStorage } from '../cart/ShopInfos';
import { getHostApi, getRequestConfig, getRequestConfigForFetch, getInfosI18n } from "../../utils";
import dispatcher from "../dispatcher";
import { Customer, CustomerCreditInfos } from './iMonCompte';

/**
 * @deprecated
 * Fonction permettant de récuperer le x-xsrf-token
 */
export function getHeadersToken(): any {
  return {
    'x-xsrf-token': localStorage.getItem('xsrfToken'),
  };
}

/**
 * Fonction permettant de récupérer le user connecté
 */
export async function getUser(): Promise<{customer: Customer}> {
  const response = await fetch(`${getHostApi()}/customers/${getUserId()}`, {
    ...getRequestConfigForFetch(),
    method: 'GET',
  });
  if (response.status >= 400) {
    throw new Error(`Error fetching user: ${response.statusText}`);
  }
  return response.json()
    .then((res) => {
    if (res.customer) {
      sessionStorage.setItem('customerStruct', JSON.stringify(res.customer));
      dispatcher.dispatch({
        type: 'REFRESH_USER',
        value: res.customer,
      });
    }
    return res;
  });
}

export function login(values: any) {
  return axios.post(`${getHostApi()}/customers/auth`, values, getRequestConfig())
    .then((response) => {
      if (response.data.customer) {
        sessionStorage.setItem('customerStruct', JSON.stringify(response.data.customer));
        dispatcher.dispatch({
          type: 'REFRESH_USER',
          value: response.data.customer,
        });
      }
    });
}

export function logout() {
  return axios.post(`${getHostApi()}/customers/logout`, {}, getRequestConfig())
    .then((response) => {
      sessionStorage.removeItem('customerStruct');
      dispatcher.dispatch({
        type: 'REMOVE_USER'
      });
    }).catch((err) => {
      console.error(err);
    });
}

export function recovery() {
  return axios.post(`${getHostApi()}/customers/recovery`, {}, getRequestConfig())
    .then((response) => {
      if(response.data.customer) {
        sessionStorage.setItem('customerStruct', JSON.stringify(response.data.customer));
        dispatcher.dispatch({
          type: 'REFRESH_USER',
          value: response.data.customer,
        });
      } else {
        throw new Error("session is invalid");
      }
    });
}

export const getAuthorizedFilesExtension = (isBatAuto: boolean = false): any => {
  return axios.get(`${getHostApi()}/customers/${getUserId()}/galleries/authorized-file-extensions`,
    getRequestConfig(),
  ).then((response) => {
    if(isBatAuto) {
      return response.data.authorized_files_bat_auto;
    } else {
      return response.data.authorized_files;
    }
  }).catch((error) => {
    console.log(error);
  });
};

/**
 * Fonction permettant de récupérer le user id dans le sessionStorage
 */
export function getUserId() {
  const storageUser = sessionStorage.getItem('customerStruct');
  if (storageUser) {
    const user = JSON.parse(storageUser);
    if (user && user.idClient) {
      return user.idClient;
    }
  }
}

/**
 * Fonction permettant de récupérer le role d'un utilisateur
 */
export function getRole() {
  return axios.get(`${getHostApi()}/customers/${getUserId()}/role`,
  getRequestConfig(),
  ).then((response) => {
    return response.data;
  }).catch((error) => {
    console.log(error);
  });
}

/**
 * Fonction permettant de récupérer les competences d'un utilisateur
 */
export function getCompetences() {
  return axios.get(`${getHostApi()}/customers/${getUserId()}/competences`,
    getRequestConfig(),
  ).then((response) => {
    return response.data;
  }).catch((error) => {
    console.log(error);
  });
}

/**
 * Fonction permettant de récupérer la couleur de la boutique dans le sessionStorage
 */
export function getBoutiqueColor() {
  let colorMain = '#333333';
  const shopInfos = getShopInfosInStorage();

  if (shopInfos) {
    if (shopInfos.Ref === 'TO') {
      colorMain = '#C89E64';
    }
    if (shopInfos.Ref === 'TE') {
      // colorMain = 'rgb(117, 174, 33)';
    }
    if (shopInfos.Ref === 'ME') {
      colorMain = '#dd0055';
    }
    if (shopInfos.Ref === 'DG') {
      colorMain = '#f07e26';
    }
    if (shopInfos.Ref === 'TH') {
      colorMain = '#000000';
    }
  }

  return colorMain;
}

export function getShopRefInStorage() {
  let boutique = '';
  const shopInfos = getShopInfosInStorage();

  if (shopInfos) {
    boutique = shopInfos.Ref;
  }

  return boutique;
}

export function getCgvLink() {
  const boutique = getShopRefInStorage();

  if (boutique === 'TO') {
    return 'support-cgv';
  }
  if (boutique === 'TE') {
    return 'cgv';
  }
  if (boutique === 'ME' || boutique === 'MT') {
    return 'conditions';
  }
}

export function getPolitiqueDeConfidentialiteLink() {
  const boutique = getShopRefInStorage();

  if (boutique === 'TO') {
    return 'support-politique-confidentialite';
  }
  if (boutique === 'TE') {
    return 'aide-politique-confidentialite';
  }
  if (boutique === 'ME' || boutique === 'MT') {
    return 'politique-confidentialite';
  }
}

export function getShopDomainInStorage() {
  let boutique = '';
  const shopInfos = getShopInfosInStorage();

  if (shopInfos) {
    boutique = shopInfos.domaine;
  }

  return boutique;
}

export function formatPrice(price: string) {
  const { locale } = getInfosI18n();
  return parseFloat(price).toLocaleString(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

export function sessionExpire() {
  alert('Votre session est expirée, veuillez vous reconnecter');
  window.location.href = '/?deconnexion';
}

export function getExpirationText(
    textContents: Record<string, string|undefined>,
    creditsInfos: CustomerCreditInfos
  ): string {
    const { locale } = getInfosI18n();
    const text = textContents?.['MC_MENU_TEXT_CREDITS_EXPIRATION'] ?? 'Expiration de  crédits le ';
    const date = new Date(creditsInfos.expirationDate.replace(' ', 'T'));
    const expirationDate = date.toLocaleDateString(locale, { year: 'numeric', month: 'short', day: '2-digit' });
    return text.replace('  ', ` ${creditsInfos.totalCredits.toLocaleString(locale)} `).concat(expirationDate);
}
